import { SVGProps } from "react"

export const Ruler = (props: SVGProps<SVGSVGElement>) => (
    <svg version="1.1" id="Laag_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 50 50" {...props}>
        <rect
            x="1.9"
            y="16.4"
            transform="matrix(0.7071 -0.7071 0.7071 0.7071 -10.2888 24.9594)"
            fill="#D2A971"
            width="46.2"
            height="17"
        />
        <path
            d="M35.1,1.5c-0.2,0-0.4,0.1-0.6,0.3L1.9,34.4c-0.4,0.4-0.4,1,0,1.4L14.1,48c0.4,0.4,1,0.4,1.4,0l0,0l32.6-32.6
	c0.4-0.4,0.4-1,0-1.4L35.9,1.8c0-0.1-0.1-0.1-0.2-0.2C35.6,1.5,35.4,1.5,35.1,1.5L35.1,1.5z M35.2,3.9L46,14.7L14.8,45.9L4,35.1
	l2.8-2.8l2.4,2.4l1.4-1.4l-2.4-2.4l2.6-2.6l5.4,5.4l1.4-1.4l-5.4-5.4l2.6-2.6l2.4,2.4l1.4-1.4l-2.4-2.4l2.6-2.6l5.4,5.4l1.4-1.4
	l-5.4-5.4l2.6-2.6l2.4,2.4l1.4-1.4l-2.4-2.4l2.6-2.6l5.4,5.4l1.4-1.4l-5.4-5.4l2.6-2.6l2.4,2.4l1.4-1.4l-2.4-2.4L35.2,3.9z"
        />
    </svg>
)
